import Lottie from 'react-lottie-player';
import loaderAnim from '@lotties/loader.json';
import {CenterContainer, LoaderContainer} from './RainbowLoader.styled';

interface Props {
    disableWidth?:boolean
}
export const RainbowLoader = (props:Props) => {
  const options = {
    loop: true,
    animationData: loaderAnim,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <LoaderContainer>
        <CenterContainer>
            <Lottie {...options} play style={{width:'100%',height:'100%',overflow:'hidden',margin:'0 auto'}} />
        </CenterContainer>
    </LoaderContainer>
  );
};

export default RainbowLoader;
